import type { SVGProps } from 'react';
import * as React from 'react';

const SvgSearch24 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.25}
      d="M10.97 19.19a8.22 8.22 0 0 1-8.22-8.22 8.22 8.22 0 0 1 8.22-8.22 8.22 8.22 0 0 1 8.22 8.22 8.22 8.22 0 0 1-8.22 8.22M21.25 21.25l-4.11-4.11"
    />
  </svg>
);
export default SvgSearch24;
